import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';


export default register('testimonials', {
  onLoad() {

    const sliders = this.container.querySelectorAll('.testimonials__slider');
    sliders.forEach(slider => {
      new Flickity(slider, {
        prevNextButtons: false,
        pageDots: true,
        cellAlign: 'left',
        watchCSS: true,
      });
    });

  },
});
